import { render, staticRenderFns } from "./EmailLayoutsListPage.vue?vue&type=template&id=4da56531&scoped=true&"
import script from "./EmailLayoutsListPage.vue?vue&type=script&lang=ts&"
export * from "./EmailLayoutsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmailLayoutsListPage.vue?vue&type=style&index=0&id=4da56531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da56531",
  null
  
)

export default component.exports